// =============================================================================
// components/charts/plugins.js
//
// Plugins inline do Chart.js 2.x para desenhar valores nos gráficos, sem
// depender de nenhum package externo (ex.: chartjs-plugin-datalabels).
// Passam-se por chart via a prop `plugins` do react-chartjs-2.
// =============================================================================

const FONT = '"IBM Plex Sans", sans-serif'
const INK  = '#1a2233'
const MUTE = '#4a5568'

// ── Valor no topo/ponta de cada barra (bar e horizontalBar) ──────────────────
export const barValues = {
  afterDatasetsDraw(chart) {
    const ctx = chart.ctx
    const horizontal = chart.config.type === 'horizontalBar'
    ctx.save()
    ctx.font = `600 11px ${FONT}`
    ctx.fillStyle = INK
    chart.data.datasets.forEach((ds, di) => {
      const meta = chart.getDatasetMeta(di)
      if (meta.hidden) return
      meta.data.forEach((el, i) => {
        const v = ds.data[i]
        if (v == null || v === 0) return
        const m = el._model
        if (horizontal) {
          ctx.textAlign = 'left'; ctx.textBaseline = 'middle'
          ctx.fillText(v, m.x + 6, m.y)
        } else {
          ctx.textAlign = 'center'; ctx.textBaseline = 'bottom'
          ctx.fillText(v, m.x, m.y - 4)
        }
      })
    })
    ctx.restore()
  },
}

// ── Total no topo de cada coluna empilhada ───────────────────────────────────
export const stackTotals = {
  afterDatasetsDraw(chart) {
    const ctx = chart.ctx
    const { datasets, labels } = chart.data
    ctx.save()
    ctx.font = `600 11px ${FONT}`
    ctx.fillStyle = INK
    ctx.textAlign = 'center'; ctx.textBaseline = 'bottom'
    labels.forEach((_, i) => {
      let total = 0, topY = null, x = null
      datasets.forEach((ds, di) => {
        const meta = chart.getDatasetMeta(di)
        if (meta.hidden) return
        total += Number(ds.data[i]) || 0
        const el = meta.data[i]
        if (el) { const m = el._model; x = m.x; if (topY == null || m.y < topY) topY = m.y }
      })
      if (total > 0 && x != null) ctx.fillText(total, x, topY - 4)
    })
    ctx.restore()
  },
}

// ── Valor em cada fatia + total no centro (doughnut) ─────────────────────────
export const doughnutValues = {
  afterDatasetsDraw(chart) {
    const ctx = chart.ctx
    const meta = chart.getDatasetMeta(0)
    const ds = chart.data.datasets[0]
    if (!ds) return
    const total = ds.data.reduce((s, v) => s + (Number(v) || 0), 0)

    ctx.save()
    // Valor por fatia (só se a fatia for grande o suficiente para caber texto)
    ctx.font = `600 11px ${FONT}`
    ctx.fillStyle = '#ffffff'
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle'
    meta.data.forEach((el, i) => {
      const v = Number(ds.data[i]) || 0
      if (v === 0) return
      const m = el._model
      if ((m.endAngle - m.startAngle) < 0.28) return
      const mid = (m.startAngle + m.endAngle) / 2
      const r   = (m.innerRadius + m.outerRadius) / 2
      ctx.fillText(v, m.x + Math.cos(mid) * r, m.y + Math.sin(mid) * r)
    })

    // Total no centro
    const c = meta.data[0] && meta.data[0]._model
    if (c) {
      ctx.fillStyle = INK
      ctx.font = `600 18px ${FONT}`
      ctx.fillText(total, c.x, c.y - 6)
      ctx.fillStyle = MUTE
      ctx.font = `400 10px ${FONT}`
      ctx.fillText('total', c.x, c.y + 11)
    }
    ctx.restore()
  },
}
